import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/Sidebar.css';

function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div className="sidebar">
      {/* Logo */}
      <div className="sidebar-logo">
        <div className="logo-icon">
          <span>ZNS</span>
        </div>
        <div className="logo-text">
          <h3>ZNS Management</h3>
          <p>Công ty TNHH NAGEN</p>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="sidebar-nav">
        <Link 
          to="/dashboard" 
          className={`menu-item ${location.pathname === '/dashboard' ? 'active' : ''}`}
        >
          <i className="icon">📊</i>
          <span>Dashboard</span>
        </Link>

        <Link 
          to="/send-zns" 
          className={`menu-item ${location.pathname === '/send-zns' ? 'active' : ''}`}
        >
          <i className="icon">📤</i>
          <span>Gửi ZNS đơn lẻ</span>
        </Link>

        <Link 
          to="/send-bulk-zns" 
          className={`menu-item ${location.pathname === '/send-bulk-zns' ? 'active' : ''}`}
        >
          <i className="icon">📨</i>
          <span>Gửi hàng loạt</span>
        </Link>

        <Link 
          to="/templates" 
          className={`menu-item ${location.pathname === '/templates' ? 'active' : ''}`}
        >
          <i className="icon">📝</i>
          <span>Quản lý Template</span>
        </Link>

        <Link 
          to="/automation" 
          className={`menu-item ${location.pathname === '/automation' ? 'active' : ''}`}
        >
          <i className="icon">⚙️</i>
          <span>Automation Rules</span>
        </Link>

        <Link 
          to="/history" 
          className={`menu-item ${location.pathname === '/history' ? 'active' : ''}`}
        >
          <i className="icon">📜</i>
          <span>Lịch sử gửi tin</span>
        </Link>

        {user.role === 'admin' && (
          <>
            <div className="menu-divider"></div>
            <div className="menu-section-title">QUẢN TRỊ</div>
            
            <Link 
              to="/users" 
              className={`menu-item ${location.pathname === '/users' ? 'active' : ''}`}
            >
              <i className="icon">👥</i>
              <span>Quản lý User</span>
            </Link>

            <Link 
              to="/settings" 
              className={`menu-item ${location.pathname === '/settings' ? 'active' : ''}`}
            >
              <i className="icon">⚙️</i>
              <span>Cài đặt hệ thống</span>
            </Link>
          </>
        )}
      </nav>

      {/* User Info Footer */}
      <div className="sidebar-footer">
        <div className="user-info">
          <div className="user-avatar">
            {user.username?.charAt(0).toUpperCase() || 'U'}
          </div>
          <div className="user-details">
            <div className="user-name">{user.username || 'User'}</div>
            <div className="user-role">{user.role === 'admin' ? 'Quản trị viên' : 'Người dùng'}</div>
          </div>
        </div>
        <button className="logout-btn" onClick={handleLogout} title="Đăng xuất">
          <i className="icon">🚪</i>
        </button>
      </div>
    </div>
  );
}

export default Sidebar;